import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/paymentMethods', request)
}

export {get}
